export const DictionaryKeyDelimiter = String.fromCharCode(157); // '¥';

export const QuestionType = {
  GENERAL: 0,
  ROOT: 1,
  LEAF: 2,
  MIDDLE: 3,
};

export const RepresentationType = {
  GENERAL: 0,
  PARENT_CHILD: 1,
};

export const SelectionType = {
  SINGLE: 0,
  MULTIPLE: 1,
};

export const ThumbnailType = {
  TEXT: 0,
  COLOR_SWATCH: 1,
  LOCAL_IMAGE: 2,
  SCENE7_IMAGE: 3,
};

export const YearOptionPricingType = {
  Ignored: 0,
  OnRegular: 1,
  OnSale: 2,
};

export const SizeQuestionCode = 'SIZ';

export const YearQuestionCode = 'CYR';

export const QuantityType = {
  Common: 0,
  Exact: 1,
  Locked: 2,
};

export const BomOptionsEventTargetDesignLater = 'design-later';
export const BomOptionsEventTargetPreselectBom = 'preselect-bom';

export const BomColorChangeEvent = 'BomColorChange';
export const BomOptionsErrorEvent = 'BomOptionsError';
export const BomOptionsLoadingCompletedEvent = 'BomOptionsLoadingCompleted';
export const BomOptionsSavingStartEvent = 'BomOptionsSavingStart';
export const BomOptionsSavingCompletedEvent = 'BomOptionsSavingCompleted';
export const BomOptionsValidationPassedEvent = 'BomOptionsValidationPassed';

export const BomOptionsStepSeparateQuantity = 'separate-quantity';
